import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import PersonAffiliationsForm from "./AffiliationsToPersonsForm";
import { updatePersonAffiliationsToPerson } from "common/services/persons.service";
import { toast } from "react-toastify";

const UpdateAffiliationsToPersons: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  data: any;
  personId: string;
}> = ({ toggle, isModalOpen, personId, data, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      affiliations: (data.length &&
        data.map((item: any) => ({
          id: item.id,
          affiliatedTo: {
            value: item.affiliatedTo?.id || "",
            label: `${item?.affiliatedTo?.fullName || ""}`,
          },
          natureOfRelationship: item.natureOfRelationship || "",
          informationSource: item.informationSource || "",
          relationshipConfirmed: {
            value: item.relationshipConfirmed,
            label: item.relationshipConfirmed ? "Confirmed" : "Not confirmed",
          },
        }))) || [
        {
          affiliatedTo: {
            value: "",
            label: "",
          },
          natureOfRelationship: "",
          informationSource: "",
          relationshipConfirmed: {
            value: false,
            label: "Not confirmed",
          },
        },
      ],
    },
    validationSchema: Yup.object({
      affiliations: Yup.array().of(
        Yup.object({
          affiliatedTo: Yup.object().shape({
            value: Yup.string().required("Required"),
            label: Yup.string(),
          }),
          natureOfRelationship: Yup.string().nullable(),
          informationSource: Yup.string().nullable(),
          relationshipConfirmed: Yup.object().shape({
            value: Yup.boolean(),
            label: Yup.string(),
          }),
        })
      ),
    }),
    onSubmit: (values: any) => {
      const data = {
        id: personId,
        data: values.affiliations?.map((item: any) => ({
          ...item,
          affiliatedTo: item.affiliatedTo?.value,
          relationshipConfirmed: item.relationshipConfirmed?.value,
        })),
      };

      setLoading(true);
      const saveData = async () => {
        try {
          await updatePersonAffiliationsToPerson(data);
          validation.resetForm();
          toggle();
          toast.success("Affiliations Updated Successfully", {
            autoClose: 1000,
          });
        } catch (err: any) {
          toast.error("Error while updating affiliations", {
            autoClose: 1000,
          });
        } finally {
          setLoading(false);
          fetchData();
        }
      };
      saveData();
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Affiliation to Persons
        <small
          color="light"
          className="badge bg-primary-subtle align-bottom ms-1 text-primary"
        >
          {validation?.values?.affiliations?.length || 0}
        </small>
      </ModalHeader>

      <PersonAffiliationsForm
        toggle={toggle}
        validation={validation}
        isUpdate
        loading={loading}
        currentPersonId={personId}
      />
    </Modal>
  );
};

export default UpdateAffiliationsToPersons;
